import { createSelector } from "@ngrx/store";

import { CoreState } from "../state";

import { Page } from "./page.model";

export namespace PageSelector2 {
	export const getAll = (state: CoreState): Record<string, Page> => state.page.pages;

	export const get = (key: string) => createSelector(getAll, (pages): Page | undefined => pages?.[key]);

	export const getCurrent = (state: CoreState): Page | undefined => state.page.current;
}
